import { render, staticRenderFns } from "./CustomEdit.vue?vue&type=template&id=60b2061c&"
import script from "./CustomEdit.vue?vue&type=script&lang=ts&"
export * from "./CustomEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports